module.exports = __webpack_public_path__ + "static/media/eye.bfef6de2.png";